import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BuildPakAttribute, IBuildPakAttribute } from '../../../../../../core/models';

@Component({
  selector: 'app-test-attr-c',
  templateUrl: './test-attr-c.component.html',
  styleUrls: ['./test-attr-c.component.scss']
})
export class TestAttrCComponent implements OnInit {

  @Input() attrs: any;
  @Input() disabled: boolean;
  //@Input() isError: boolean;
  @Output() attrChange = new EventEmitter<IBuildPakAttribute>();
  checked: boolean = false;
  constructor() {

  }


  ngOnInit() {
    if (this.attrs.type === 'list' && !this.attrs.value) { this.attrs.value = ''; }
    if (this.attrs.type === 'switch') {
      //console.log(this.attrs.value);
      if (this.attrs.value && this.attrs.value.toUpperCase() === 'TRUE') {
        this.checked = true;
      }
      else { this.checked = false; }
    }
    //hack for  2000T
    if (this.attrs.type === 'text' && this.attrs.name == 'Std Hinges') {
      this.disabled = true;
    }
    //make Frame Width and Height read-only.These numbers should  be based on DOW and DOH:
    if (this.attrs.type === 'text' &&
      (
        //this.attrs.v6ReferenceCode == 'TRFrm_Height' ||
        this.attrs.v6ReferenceCode == 'Frm_Width' ||
        this.attrs.v6ReferenceCode == 'Frm_Height')) {
      this.disabled = true;
    }

    //hack for  Glassvent UT
    if (this.attrs.type === 'text' && this.attrs.v6ReferenceCode == 'Vent Type Limits') {
      this.disabled = true;
      this.attrs.type = 'readOnlyText';
    }
  }
  executeMacro(attrs) {
    //console.log(JSON.stringify(attrs));
    if (this.attrs.type === 'switch') {
      if (this.checked) { this.attrs.value = 'True' }
      else { this.attrs.value = 'False' }
    }
    this.attrChange.emit(attrs);
  }

  //valueRefresh() {
  //  const regex = /^([1-2]?[0-9]{1,3})\'([0-9]|[0-1]{2})\"$/gm;
  //  let temp = [];
  //  if ((temp = regex.exec(this.sourceValue))) {
  //    this.srcAttrValue = temp[0];
  //  } else {
  //    this.srcAttrValue = '';
  //  }

}
